// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__DgEqM","menuItem":"Sidebar_menuItem__ynf5D","active":"Sidebar_active__ORiHP"};